export const ANONYMOUS_PLATFORM_IDENTITY_HASH = 'P-anonymous'
